import React from 'react'
import cn from 'classnames'

import Heading from 'components/Heading/Heading'
import Wrapper from 'components/Wrapper/Wrapper'

import styles from './ContentPage.module.css'

type TitleProps = {
  children?: React.ReactNode
}

const Title = ({ children }: TitleProps) => (
  <Wrapper>
    <Heading level="h2">
      <h1>{children}</h1>
    </Heading>
  </Wrapper>
)

type ContentPageProps = {
  centered?: boolean
  title: string
}

const ContentPage: React.FC<ContentPageProps> = ({
  title,
  children,
  centered = false,
}) => {
  return (
    <main className={cn(styles.content, { [styles.centered]: centered })}>
      {title && <Title>{title}</Title>}
      {children}
    </main>
  )
}

export default ContentPage
